import { fetchProductsData, fetchProductData } from "./actions/fetchActions";
import {
  productsReducer,
  productReducer,
  createProductReducer,
  updateProductReducer,
  deleteProductReducer,
} from "./reducers/fetchReducers";

const productsReducers = {
  productsGlobalStore: productsReducer,
  productGlobalStore: productReducer,
  createProductGlobalStore: createProductReducer,
  updateProductGlobalStore: updateProductReducer,
  deleteProductGlobalStore: deleteProductReducer,
};

export { fetchProductsData, fetchProductData, productsReducers };
